export type GemiusImpressData = {
	readonly identifier: string;
	readonly extra: string;
};

export const GEMIUS_SCRIPT_URL = 'https://gacz.hit.gemius.pl/xgemius.js';

/**
 * Copypasted from sRreality
 * https://gitlab.seznam.net/uhor/sreality-frontend/-/blob/master/web/lib/gemius/index.ts?ref_type=heads
 */
export function gemiusImpress(impressData: GemiusImpressData): void {
	// #if [DEV]
	// eslint-disable-next-line no-console
	console.log('Faking gemiusImpress with data:', impressData);
	// #else
	globalThis.window.pp_gemius_hit?.(impressData.identifier, impressData.extra);
	// #endif
}

// Required to be like string to be able to be injected into the page at the very beginning instead of being bundled
export const gemiusInlineScript = `
globalThis.window.pp_gemius_use_cmp = true;
globalThis.window.pp_gemius_cmp_timeout = 10000;

function gemiusPending(name) {
	window[name] =
		window[name] ||
		function () {
			window[name + '_pdata'] = window[name + '_pdata'] || [];
			window[name + '_pdata'].push(arguments);
		};
}

gemiusPending('gemius_hit');
gemiusPending('gemius_event');
gemiusPending('pp_gemius_hit');
gemiusPending('pp_gemius_event');
`;
